import axios from 'axios';

export const shouldClearAuthentication = (status) => status === 401;

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && shouldClearAuthentication(error.response.status)) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default instance;
